<template>
    <div class="container">
        <b-row>
            <b-col md="7" lg="auto" class="mt-2 mx-auto">
                <b-form id="create-form">
                    <div class="content mb-4">
                        <h4>{{ labels.title }}</h4>
                    </div>
                    <b-row class="mt-3">
                        <b-col cols="2" class="text-left">
                            <h5>{{labels.numeroContrato}}</h5>
                        </b-col>
                        <b-col cols="4" class="text-left">
                            <input type="number" v-model="numeroContrato" class="form-control">
                        </b-col>
                        <b-col cols="2" class="text-left">
                            <h5>{{labels.arrendador}}</h5>
                        </b-col>
                        <b-col cols="4" class="text-left">
                            <select v-model="arrendador" class="form-control">
                                <option value="">{{ labels.select }}</option>
                                <option v-for="tercero in listTercero" :key="tercero.id" :value="tercero.identificacion">{{ tercero.nombre }}</option>
                            </select>
                        </b-col>
                    </b-row>
                    <b-row class="mt-3">
                        <b-col cols="2" class="text-left">
                            <h5>{{labels.tipoContrato}}</h5>
                        </b-col>
                        <b-col cols="4" class="text-left">
                            <select v-model="tipoContrato" class="form-control">
                                <option value="">{{ labels.select }}</option>
                                <option v-for="tpContrato in listTipoContrato" :key="tpContrato.id" :value="tpContrato.tipo_contrato">{{ tpContrato.descripcion }}</option>
                            </select>
                        </b-col>
                        <b-col cols="2" class="text-left">
                            <h5>{{labels.tipoActivo}}</h5>
                        </b-col>
                        <b-col cols="4" class="text-left">
                            <select v-model="tipoActivo" class="form-control">
                                <option value="">{{ labels.select }}</option>
                                <option v-for="tpActivo in lstTipoActivo" :key="tpActivo.id" :value="tpActivo">{{ tpActivo.descripcion }}</option>
                            </select>
                        </b-col>
                    </b-row>
                    <b-row class="mt-3 justify-content-center" v-if="lstSelActivos != 0">
                        <div class="content mb-2">
                            <h5>{{ labels.listadoActivos }}</h5>
                        </div>
                        <b-col cols="12" class="justify-content-center">
                            <select multiple class="form-control" v-model="activosSelected">
                                <option v-for="activosSel in lstSelActivos" :key="activosSel.id" :value="activosSel.activo">{{ activosSel.descripcion }}</option>
                            </select>
                        </b-col>
                    </b-row>
                    <b-row v-if="lstSelActivos == 0" class="mt-2 justify-content-center">
                        <h6 v-if="sinActivos">{{ labels.noActivDispo }}</h6>
                    </b-row>
                    <b-row class="mt-3">
                        <b-col cols="2" class="text-left">
                            <h5>{{labels.fechaInicial}}</h5>
                        </b-col>
                        <b-col cols="4" class="text-left">
                            <input type="date" v-model="fechaInicial" class="form-control">
                        </b-col>
                        <b-col cols="2" class="text-left">
                            <h5>{{labels.fechaFinal}}</h5>
                        </b-col>
                        <b-col cols="4" class="text-left">
                            <input type="date" v-model="fechaFinal" class="form-control" v-on:focus="fgl_guardar=false">
                        </b-col>
                    </b-row>
                    <b-row class="mt-3 justify-content-center">
                        <div class="content mb-2">
                            <h5>{{ labels.condicionesTasa }} {{f_calcula_cuotas(fechaInicial,fechaFinal,30)}} (Meses)</h5>
                        </div>
                    </b-row>
                    <b-row class="mt-3">
                        <b-col cols="2" class="text-left">
                            <h5>{{labels.tasa}}</h5>
                        </b-col>
                        <b-col cols="4" class="text-left">
                            <select v-model="tipoTasa" class="form-control" v-on:click="valideTasa()" v-on:focus="fgl_guardar=false">
                                <option value="">{{ labels.select }}</option>
                                <option v-for="tipTasa in listTipoTasa" :key="tipTasa.id" :value="tipTasa.tipo_tasa">{{ tipTasa.descripcion }}</option>
                            </select>
			</b-col>
                        <b-col cols="1"><h4>+</h4></b-col>
                        <b-col cols="4" class="text-left">
                            <input type="number" v-model="tasa" class="form-control" v-on:focus="fgl_guardar=false">
                        </b-col>
                    </b-row>
                    <b-row class="mt-3">
                        <b-col cols="2" class="text-left">
                            <h5>{{labels.frecuencia}}</h5>
                        </b-col>
                        <b-col cols="4" class="text-left">
                            <select v-model="frecuencia" class="form-control" v-on:focus="fgl_guardar=false">
                                <option value="">{{ labels.select }}</option>
                                <option value="30">30 días</option>
                                <option value="60">60 días</option>
                                <option value="90">90 días</option>
                                <option value="180">180 días</option>
                                <option value="360">360 días</option>
                            </select>
                        </b-col>
                        <b-col cols="1"></b-col>
                        <b-col cols="4" class="text-left">
                            <select v-model="modalidad" class="form-control" v-on:focus="fgl_guardar=false">
                                <option value="">{{ labels.select }}</option>
                                <option value="A">{{ labels.anticipada }}</option>
                                <option value="V">{{ labels.vencida }}</option>
                            </select>
                        </b-col>
                    </b-row>
                    <b-row class="mt-4 justify-content-center">
                        <div class="content mb-2">
                            <h5>{{ labels.condicionesCambioCanon }}</h5>
                        </div>
                    </b-row>
                    <b-row class="mt-3">
                        <b-col cols="2" class="text-left">
                            <h5>{{labels.incremento}}</h5>
                        </b-col>
                        <b-col cols="4" class="text-left">
                            <select v-model="tasaCambCanon" class="form-control">
                                <option value="">{{ labels.select }}</option>
                                <option v-for="tipTasa in listTipoTasa" :key="tipTasa.id" :value="tipTasa.tipo_tasa">{{ tipTasa.descripcion }}</option>
                            </select>
                        </b-col>
                        <b-col cols="1"><h4>+</h4></b-col>
                        <b-col cols="4" class="text-left">
                            <input type="number" v-model="puntAdicionCambCanon" class="form-control">
                        </b-col>
                    </b-row>
                    <b-row class="mt-3">
                        <b-col cols="2" class="text-left">
                            <h5>{{labels.periodicidadCambio}}</h5>
                        </b-col>
                        <b-col cols="4" class="text-left">
                            <input type="number" v-model="periodCambioCambCanon" class="form-control">
                        </b-col>
                        <b-col cols="1"></b-col>
                        <b-col cols="4" class="text-left"><h5>Meses</h5></b-col>
                    </b-row>
                    <b-row class="mt-3">
                        <b-col cols="2" class="text-left">
                            <h5>{{labels.canonArrendamiento}}</h5>
                        </b-col>
                        <b-col cols="4" class="text-left">
                            <input type="number" v-model="canonArrendamiento" class="form-control" v-on:blur="calculaValContrato()" v-on:focus="fgl_guardar=false" v-on:change="a_flujos_contrato=[]">
                        </b-col>
                        <b-col cols="1"></b-col>
                        <b-col cols="4">
				<b-button type="button" id="create-btn" @click="flujosContrato">{{ labels.flujos }}</b-button>
			</b-col>
                    </b-row>
                    <b-row class="mt-3">
                        <b-col cols="2" class="text-left">
                            <h5>{{labels.valorActivo}}</h5>
                        </b-col>
                        <b-col cols="4" class="text-left">
                            <h5> ${{ Intl.NumberFormat('es-CO',{ maximumFractionDigits: 3, minimumFractionDigits: 2}).format(valorActivo) }} </h5>
                        </b-col>
                        <b-col cols="1"></b-col>
                        <b-col cols="4">
				<b-button type="button" id="create-btn" @click="addCentCost">{{labels.addCentrosCosto}}</b-button>
			</b-col>
                    </b-row>
                    <b-row class="mt-3">
                        <b-col cols="2" class="text-left">
                            <h5>{{labels.valorContrato}}</h5>
                        </b-col>
                        <b-col cols="4" class="text-left">
                            <h5> ${{ Intl.NumberFormat('es-CO',{ maximumFractionDigits: 3, minimumFractionDigits: 2}).format(valorContrato) }} </h5>
                        </b-col>
                        <b-col cols="1"></b-col>
                        <b-col cols="4">
				<b-button v-if="fgl_guardar==false" type="button" id="create-btn" @click="validarContrato">{{ labels.validar }}</b-button>
				<b-button v-else type="button" id="create-btn" @click="guardarContrato">{{ labels.crear }}</b-button>
			</b-col>
                    </b-row>
                </b-form>
            </b-col>
        </b-row>
        <ModAgregarCentroCosto :modAdCentCost="showAdCentroCostos" @asignaCentCost="asignarCentCost" @cierraModal="closeModal"></ModAgregarCentroCosto>
        <ModFlujosContrato :modFlujosContrato="showFlujosContrato" :aFlujosContrato='a_flujos_contrato' :valor_canon='canonArrendamiento' :numero_cuotas='numero_cuotas' @flujosContratoFC="f_flujosContrato" @cierraModalFC="closeModalFC"></ModFlujosContrato>
    </div>
</template>

<script>
import Activos from '../../services/Activos';
import Contrato from '../../services/Contrato';
import Tercero from '../../services/Tercero';
import TipoActivo from '../../services/TipoActivo';
import TipoContrato from '../../services/TipoContrato'
import TipoTasa from '../../services/TipoTasas'
import Tasas from '../../services/Tasas';
import ModAgregarCentroCosto from './ModAgregarCentroCosto.vue';
import ModFlujosContrato from './ModFlujosContrato.vue';

export default {
    name : 'Crear',
    components : { ModAgregarCentroCosto, ModFlujosContrato },
    data : () => ({
        arrendador : '',
        tipoContrato : '',
        tipoActivo : '',
        activo : '',
        frecuencia : '',
        modalidad : '',
        valContrato : null,
        canonArrendamiento : null,
        fechaInicial : null,
        fechaFinal : null,
        opcionCompra : null,
        tipoTasa : '',
        tasa : '',
        listTercero : [],
        listTipoContrato : [],
        listTipoTasa : [],
        lstTipoActivo : [],
        lstSelActivos : [],
        activosSelected : [],
        listaActivos : [],
        valorActivo : 0,
        valorContrato : 0,
        obtTasa : 0,
        tasaCambCanon : '',
        puntAdicionCambCanon : '',
        periodCambioCambCanon : '',
        sinActivos : false,
        numeroContrato : '',
        fgl_guardar : false,
        showAdCentroCostos : false,
        showFlujosContrato : false,
        centrosCosto : [],
        a_flujos_contrato : [],
	numero_cuotas : 0,
    }),
    computed:{
        labels(){
            if(this.$store.state._language == "es-ES"){
                return {
                    title : 'Crear Contrato',
                    select : 'Seleccione...',
                    save : "Guardar",
                    close : "Cerrar",
                    arrendador : 'Arrendador',
                    tipoContrato : 'Tipo contrato',
                    tipoActivo : 'Tipo activo',
                    activo : 'Activo',
                    listadoActivos : 'Listado activos',
                    valorActivo : 'Valor activos',
                    canonArrendamiento : 'Valor Canon',
                    fechaInicial : 'Inicia',
                    fechaFinal : 'Termina',
                    frecuencia : 'Frecuencia de pago',
                    modalidad : 'Modalidad',
                    tipoTasa : 'Tipo tasa',
                    tasa : 'Tasa',
                    incremento : 'Incremento',
                    valorContrato : 'Valor contrato',
                    anticipada : 'Anticipados',
                    fija : 'Fija',
                    vencida : 'Vencidos',
                    crear : 'Crear',
                    validar : 'Validar',
                    flujos : 'Flujos',
                    condicionesTasa : 'Condiciones de tasa',
                    condicionesCambioCanon : 'Condiciones cambio canon',
                    puntosAdicionales : 'Puntos adicionales',
                    periodicidadCambio : 'Cada',
                    noActivDispo : 'No hay activos',
                    numeroContrato : 'Número',
                    addCentrosCosto : 'Centro de costos'

                }
            }else{
                return {
                    title : 'Create Contract',
                    select : 'Select...',
                    save : "Save",
                    close : "Close",
                    arrendador : 'Lessor',
                    tipoContrato : 'Contract type',
                    tipoActivo : 'Active type',
                    activo : 'Active',
                    listadoActivos : 'Active list',
                    valorActivo : 'Active value',
                    canonArrendamiento : 'Lease fee',
                    fechaInicial : 'Starting date',
                    fechaFinal : 'End date',
                    frecuencia : 'Payment frequency',
                    modalidad : 'Modality',
                    tipoTasa : 'Rate type',
                    tasa : 'Rate',
                    valorContrato : 'Contract value',
                    anticipada : 'Anticipated',
                    fija : 'Fixed',
                    vencida : 'Overdue',
                    crear : 'Create',
                    validar : 'Validate',
                    flujos : 'Flows',
                    condicionesTasa : 'Rate conditions',
                    condicionesCambioCanon : 'Canon change conditions',
                    puntosAdicionales : 'Additional points',
                    periodicidadCambio : 'Periodicity of change',
                    noActivDispo : 'There are no assets',
                    numeroContrato : 'Number',
                    addCentrosCosto : 'Cost Centers'
                }
            }
        }
    },
    methods:{
        cierraModal(){
            this.$emit('cierraModal',false)
        },
        validarContrato(){
            let datosForm = [
                this.arrendador,
                this.tipoContrato,
                this.tipoActivo,
                this.frecuencia,
                this.modalidad,
                this.tipoTasa,
                this.tasa,
                this.canonArrendamiento,
                // this.valContrato,
                this.fechaInicial,
                this.fechaFinal,
                this.activosSelected,
            ]

            if(datosForm.includes('')){
                this.$toast.error('Campo(s) pendiente(s) por diligenciar')
		this.fgl_guardar=false
            }else{
		this.calculaValContrato()
		this.fgl_guardar=true
            }
        },

        guardarContrato(){
            let datosForm = [
                this.arrendador,
                this.tipoContrato,
                this.tipoActivo,
                this.frecuencia,
                this.modalidad,
                this.tipoTasa,
                this.tasa,
                this.canonArrendamiento,
                // this.valContrato,
                this.fechaInicial,
                this.fechaFinal,
                this.activosSelected,
            ]

            if(datosForm.includes('')){
                this.$toast.error('Campo(s) pendiente(s) por diligenciar')
		this.fgl_guardar=false
            }else{

                if(this.centrosCosto.length == 0){
                    this.$toast.error('Debe asignar los centros de costo.')
                    return;
                }

                const cantidadCuotas = this.f_calcula_cuotas(
			this.fechaInicial,this.fechaFinal,this.frecuencia)

                let datos = {
                    'numeroContrato' : this.numeroContrato,
                    'arrendador' : this.arrendador,
                    'tipoContrato' : this.tipoContrato,
                    'tipoActivo' : this.tipoActivo,
                    'frecuencia' : this.frecuencia,
                    'modalidad' : this.modalidad,
                    'tipoTasa' : this.tipoTasa,//Este se actualiza el nombre en el formulario de Tipo tasa por Tasa
                    'tasa' : this.tasa,//Este se actualiza el nombre en el formulario de Tasa por Puntos adicionales
                    'tasaCambCanon' : this.tasaCambCanon,
                    'puntAdicionCambCanon' : this.puntAdicionCambCanon,
                    'periodCambioCambCanon' : this.periodCambioCambCanon,
                    'canonArrendamiento' : Number(this.canonArrendamiento),
                    'valContrato' : Number(this.valorContrato),
                    'fechaInicial' : this.fechaInicial,
                    'fechaFinal' : this.fechaFinal,
                    'listActivosSel' : this.activosSelected,
                    'centrosCosto' : this.centrosCosto,
                    'cantidadCuotas' : cantidadCuotas,
                    'idUser' : this.$store.state.userId,
                    'aFlujosContrato' : this.a_flujos_contrato,
                }
                Contrato.createContrato(datos)
                .then((res) => {
                    this.$toast.success(res.data.message)
                    this.$router.push('consultarcontrato');
                    this.fgl_guardar=false
                    location.reload()
                })
                .catch((err) => {
                    if(err.response.status == 400){
                        this.$toast.error(err.response.data.message)
                    }
                })
            }
        },
	vpn(canon,cuotas,intereses){
		let vpn = 0; 
		for (let t = 0; t < cuotas; t++) {
			const v_canon=this.a_flujos_contrato[t].valor
			const flujoDeCaja = Number(v_canon);
			vpn += flujoDeCaja / Math.pow(1 + (intereses/100), t + 1);
		}
		vpn=vpn.toFixed(0)

		return vpn
	},
        consultaTasa(){

		if	(this.fechaInicial == "null" || this.fechaInicial == "undefined") {
			return 0
		}
		let año = 0
		año = this.fechaInicial.substring(0,4)
		if	(año < 2000) {
			return 0
		}
		const datos = {
			'fechaInicial' : this.fechaInicial,
			'codTasa' : this.tipoTasa,
			'puntosAdicionales' : this.tasa,
			'modalidad' : this.modalidad,
			'frecuencia' : this.frecuencia
		}
		Tasas.generarTasa(datos)
		.then((res) => {
			this.obtTasa = res.data.resultado
		})
		.catch((err) => console.log(err))
        },
        valideTasa(){

		if	(this.fechaInicial == "null" || this.fechaInicial == "undefined") {
			return;
		}
		if	(this.tipos_tasa == "null") {
			return;
		}
		const v_tipo_tasa = this.listTipoTasa.find((r_tipo_tasa) => r_tipo_tasa.tipo_tasa==this.tipoTasa)
		if	(v_tipo_tasa.descripcion.substr(0,6) == "Zscore") {
			let cuotas=this.f_calcula_cuotas(this.fechaInicial,this.fechaFinal,30)/12
			let nro_cuotas = cuotas.toFixed(2)
			let proxima_cuota = cuotas.toFixed(0)
			proxima_cuota = proxima_cuota+".00"
			const v_interpolado = this.listTipoTasa.find((r_tipo_tasa) => r_tipo_tasa.descripcion.includes("Interpolado"))
			if	(nro_cuotas != proxima_cuota) {
				if	(v_tipo_tasa.descripcion.includes("Interpolado")) {
					return
				}
				this.tipoTasa=v_interpolado.tipo_tasa
				this.f_tasa_interpolacion(this.fechaInicial,this.f_calcula_cuotas(this.fechaInicial,this.fechaFinal,30))
			} else {
				proxima_cuota=proxima_cuota.replace(".00","")
				let v_descripcion="Zscore "+proxima_cuota+" año"
				if	(proxima_cuota > "1" || proxima_cuota.length > 1) {
					v_descripcion=v_descripcion+"s"
				}
				const v_tasa_score = this.listTipoTasa.find((r_tipo_tasa) => r_tipo_tasa.descripcion==v_descripcion)
				if	(v_tasa_score == undefined) {
					this.tipoTasa=v_interpolado.tipo_tasa
					this.f_tasa_interpolacion(this.fechaInicial,this.f_calcula_cuotas(this.fechaInicial,this.fechaFinal,30))
					return
				}
				this.tipoTasa=v_tasa_score.tipo_tasa
			}
		}
        },
	f_tasa_interpolacion(fechaInicial,cuotas) {
		Tasas.interpolacion(fechaInicial,cuotas)
		.then((res) => {
			this.tasa = res.data.tasa
		})
		.catch((err) => console.log(err))
	},
	calculaValContrato(){
		this.valorContrato=0
		if	(this.canonArrendamiento == null || this.fechaFinal == null ||
			this.fechaInicial == null || this.tipoContrato == null) {
			return
		}
		const cuotas=this.f_calcula_cuotas(this.fechaInicial,this.fechaFinal,this.frecuencia)
		if	(cuotas == 0) {
			return
		}

		this.consultaTasa()
		if	(this.a_flujos_contrato.length == 0) {
			for	(let idx=0;idx<cuotas;idx++) {
				this.a_flujos_contrato.push({cuota: idx+1, valor: this.canonArrendamiento})
			}
		}
		setTimeout(() => {
			this.valorContrato = this.vpn(this.canonArrendamiento,cuotas,this.obtTasa)
			const v_tipo_contrato = this.listTipoContrato.find((tipo) => tipo.tipo_contrato == this.tipoContrato)
			if	(v_tipo_contrato.descripcion.toLowerCase() == "operativo") {
				this.valorContrato = this.valorActivo
			}
		},1000)
	},
	f_calcula_cuotas (fecha_inicial,fecha_final,frecuencia) {
		if	(fecha_inicial == null || fecha_final == null || frecuencia == null) {
			return 0
		}
		const añoinicial = fecha_inicial.substring(0,4)
		const mesinicial = fecha_inicial.substring(5,7)
		let añofinal = fecha_final.substring(0,4)
		const mesfinal = fecha_final.substring(5,7)
		if	(añoinicial>añofinal || añoinicial==añofinal && mesinicial>=mesfinal) {
			return 0
		}
		let cuotas=mesfinal-mesinicial
		
		if	(cuotas < 0) {
			cuotas=12+cuotas
			añofinal=añofinal-1
		}
		cuotas=cuotas+(añofinal-añoinicial)*12
		cuotas=cuotas*30
		cuotas=cuotas/frecuencia
		return cuotas
	},
        addCentCost(){
            this.showAdCentroCostos = true
        },
        flujosContrato(){
		if	(this.canonArrendamiento == null || this.fechaFinal == null ||
			this.fechaInicial == null || this.tipoContrato == null) {
			return
		}
		this.showFlujosContrato = true
        },
        closeModal(){
            this.showAdCentroCostos = false
        },
        closeModalFC(){
		this.showFlujosContrato = false
        },
        asignarCentCost(infoCentCost){
            // console.log('CENTRO COSTO:', infoCentCost);
            this.centrosCosto = infoCentCost
        },
        f_flujosContrato(infoFlujosContrato){
		this.a_flujos_contrato = infoFlujosContrato
		const cuotas=this.f_calcula_cuotas(this.fechaInicial,this.fechaFinal,this.frecuencia)
		this.valorContrato = this.vpn(this.canonArrendamiento,cuotas,this.obtTasa)
		const v_tipo_contrato = this.listTipoContrato.find((tipo) => tipo.tipo_contrato == this.tipoContrato)
		if	(v_tipo_contrato.descripcion.toLowerCase() == "operativo") {
			this.valorContrato = this.valorActivo
		}
		this.showFlujosContrato = false
        }
    },
    mounted(){
        Tercero.getAllTercero()
        .then((res) => {
            this.listTercero = res.data.listTercero
        })
        .catch((err) => console.log(err))

        TipoContrato.getAllTipoContrato()
        .then((res) => {
            // console.log(res.data.listTipoContrato);
            this.listTipoContrato = res.data.listTipoContrato
        })
        .catch((err) => console.log(err))

        TipoTasa.getAllTipoTasas()
        .then((res) => {
            // console.log(res.data);
            this.listTipoTasa = res.data.listTipoTasas
        })
        .catch((err) => console.log(err))

        TipoActivo.getAllTipoActivo()
        .then((res) => {
            // console.log(res.data.listTipoActivo);
            this.lstTipoActivo = res.data.listTipoActivo
        })
        .catch((err) => console.log(err))
    },
    watch:{
        tipoActivo(valNew){
            Activos.getActivoByTipoActivo(valNew.tipo_activo)
            .then((res) => {
                this.lstSelActivos = res.data.activoByTipoAct
                this.lstSelActivos = this.lstSelActivos.filter((obj) => obj.proveedor == this.arrendador)
                const activosDisponibles = this.lstSelActivos.filter((act) => act.id_estado_activo == 1)
                this.lstSelActivos = activosDisponibles

                if(this.lstSelActivos.length != 0){
                    this.sinActivos = false
                }else{
                    this.sinActivos = true
                }
                
            })
            .catch((err) => console.log(err))
        },
        activosSelected(actSel){
		this.valorActivo = 0
		actSel.forEach((seleccion) => {
			const v_activo = this.lstSelActivos.find((activo) => activo.activo == seleccion)
			if	(v_activo != undefined) {
				this.valorActivo = parseFloat(this.valorActivo)+
					parseFloat(v_activo.valor_compra)
			}
		})
        },
    }
}
</script>

<style>

</style>
